/**
 * orga-app-api - kontaktverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KontaktRequest { 
    kontakt_id: string;
    funktionsbereich_id: string;
}

